var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOopsytwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_164)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 0H0V90H90V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0831 23.2261L57.5847 66.6735H64.9446L32.4429 23.2261H25.0831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9497 0.494629C20.3975 0.494629 0.494507 20.3977 0.494507 44.9498C0.494507 69.5018 20.3975 89.4048 44.9497 89.4048C69.5017 89.4048 89.4047 69.5018 89.4047 44.9498C89.4047 20.3977 69.5017 0.494629 44.9497 0.494629ZM55.8479 70.1448L41.0514 50.3604L22.7378 70.1448H18.0305L38.948 47.5479L18.1619 19.7545H34.1825L47.8096 37.9751L64.6748 19.7545H69.3821L49.9127 40.7887L71.8687 70.1448H55.8479Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOopsytwitter);
export default __webpack_public_path__ + "static/media/oopsytwitter.795b9163a455f8b300e10a756f111918.svg";
export { ForwardRef as ReactComponent };